<template>
  <div class="solutions-page">
    <div class="page-header">
      <div class="container">
        <h1>行业案例</h1>
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>行业案例</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="section">
        <div class="section-title">
          <h2>行业案例</h2>
          <p>我们为各行业提供专业的造价咨询服务</p>
        </div>
        <div class="solutions-list">
          <div class="solution-item">
            <div class="solution-icon">
              <i class="el-icon-office-building"></i>
            </div>
            <div class="solution-content">
              <h3>某县智慧停车场建设项目系统平台搭建设备采购造价咨询服务（信息化类）</h3>
              <p>项目概况：本项目主要内容为洛
                阳市某县智慧停车场建设系统软件
                开发及硬件设备采购、综合布线、
                安防、监控以及机房建设项目，其
                中包含了智慧驾驶舱、AIOT物联感
                知平台、智慧执法管理系统、
                GIS(地理信息系统)、传感器、服务
                器、存储设备、防火墙等。投资金
                额：约1500万元。</p>
            </div>
          </div>
          <div class="solution-item">
            <div class="solution-icon">
              <i class="el-icon-office-building"></i>
            </div>
            <div class="solution-content">
              <h3>某景区智能化票务系统更新升级项目造价咨询服务（信息化类）</h3>
              <p>项目概况：项目主要内容为对某景区智能票务系统部分功能进行增加开发，以及对部分硬件设备进行重新采购、项目综合布线、机房建设等。
                建设范围为某景区范围内的3个售票中心、4个检票景点、1个管理中心、3个票务机房、1个线上云服务系统，以及和第三方票务平台进行系统对接。投资金额：约为1000万元。</p>
<!--              <h4>主要功能</h4>-->
<!--              <ul>-->
<!--                <li>投资估算与投资决策咨询</li>-->
<!--                <li>设计阶段限额设计与优化</li>-->
<!--                <li>招投标控制价编制及审核</li>-->
<!--                <li>施工阶段变更管理与造价控制</li>-->
<!--                <li>工程结算与竣工决算</li>-->
<!--                <li>工程造价数据统计与分析</li>-->
<!--              </ul>-->
<!--              <h4>应用领域</h4>-->
<!--              <ul>-->
<!--                <li>房屋建筑工程</li>-->
<!--                <li>市政基础设施工程</li>-->
<!--                <li>交通道路工程</li>-->
<!--                <li>水利水电工程</li>-->
<!--                <li>工业与民用建筑</li>-->
<!--              </ul>-->
            </div>
          </div>
          <div class="solution-item">
            <div class="solution-icon">
              <i class="el-icon-office-building"></i>
            </div>
            <div class="solution-content">
              <h3>信息化档案管理系统造价咨询服务（信息化类）</h3>
              <p>项目概况：主要内容为某部“信息化档案管理系统”的软件开发费用计算及三年的系统运行维护费用计算，以及系统配套的国产硬件设施、配套数据库、中间件及基础软件的采购。投资金额：约150万元。</p>
            </div>
          </div>
          <div class="solution-item">
            <div class="solution-icon">
              <i class="el-icon-office-building"></i>
            </div>
            <div class="solution-content">
              <h3>某市医保管理系统造价咨询服务（信息化类）</h3>
              <p>项目概况：主要内容为某市医保反欺诈大数据应用监管系统，中间包含软件开发、硬件采购，HIS系统、反欺诈系统、AI模型、数据治理等。投资金额：约800万元。</p>
<!--              <h4>主要功能</h4>-->
<!--              <ul>-->
<!--                <li>BIM模型工程量自动提取</li>-->
<!--                <li>与计价软件无缝集成</li>-->
<!--                <li>造价数据可视化展示</li>-->
<!--                <li>多专业协同与冲突检查</li>-->
<!--                <li>设计变更造价影响分析</li>-->
<!--              </ul>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Solutions'
}
</script>

<style scoped lang="scss">
.solutions-list {
  .solution-item {
    display: flex;
    margin-bottom: 30px;
    padding: 30px;
    background-color: #f5f5f5;
    border-radius: 4px;
    
    .solution-icon {
      flex: 0 0 100px;
      text-align: center;
      margin-right: 20px;
      
      i {
        font-size: 60px;
        color: #1ebec8;
      }
    }
    
    .solution-content {
      flex: 1;
      
      h3 {
        margin-top: 0;
        margin-bottom: 15px;
        font-size: 20px;
      }
      
      p {
        color: #666;
        margin-bottom: 15px;
      }
      
      .read-more {
        color: #1ebec8;
        text-decoration: none;
        font-weight: bold;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.page-header {
  background-image: url('/img/bg2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0;
  color: #fff;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 500;
    color: #fff;
  }

  .breadcrumb {
    margin-top: 10px;

    .el-breadcrumb {
      font-size: 14px;

      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(255, 255, 255, 0.8);

          &:hover {
            color: #fff;
          }
        }

        &:last-child {
          .el-breadcrumb__inner {
            color: #fff;
          }
        }
      }
    }
  }
}
</style> 